"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.npmConfig = exports.getAppConfigInstance = exports.default = void 0;
var _docsConfig = _interopRequireDefault(require("@tencent/docs-config"));
var getAppConfigInstance = function getAppConfigInstance() {
  var instance = _docsConfig.default === null || _docsConfig.default === void 0 ? void 0 : _docsConfig.default.getInstance();
  return instance;
};
exports.getAppConfigInstance = getAppConfigInstance;
var appConfigInstance = getAppConfigInstance();

// @ts-ignore
var npmConfig = appConfigInstance === null || appConfigInstance === void 0 ? void 0 : appConfigInstance.getConfig('npm["@tencent/docs-scenario-components"]');
exports.npmConfig = npmConfig;
var _default = appConfigInstance;
exports.default = _default;